export const FRAUDS_URL =
  'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=AlpZNW1NrESZ4fmrTNhy22tYXZhRT1NPjCNff47O_XNUM0k0MzRXQUNYMUZCQjI0NkRaVjJMRFk2UiQlQCN0PWcu'
